'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var icons = require('@tempi/icons');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const PercentageWarning = ({
  totalPercentage = 100
}) => {
  if (totalPercentage === 100)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Content, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "InforOutlined",
          style: { fontSize: 40 }
        }),
        /* @__PURE__ */ jsxRuntime.jsx("div", {
          children: "T\u1ED5ng x\xE1c xu\u1EA5t r\u01A1i qu\xE0 ph\u1EA3i b\u1EB1ng 100%."
        }),
        /* @__PURE__ */ jsxRuntime.jsxs("div", {
          children: [
            "T\u1ED5ng x\xE1c xu\u1EA5t hi\u1EC7n t\u1EA1i: ",
            totalPercentage,
            "%"
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
`;
const Content = styled__default["default"].div`
  color: #e6983a;
  width: 304px;
  background-color: #fffbf5;
  text-align: center;
  border-radius: 8px;
  padding: 8px 12px;
`;

exports.PercentageWarning = PercentageWarning;
